import { actions, selectors } from '@sloyd/store-base';
import { get } from 'lodash';
import { delay, fork, put, select, takeEvery } from 'saga-ts';
import { $a, guid4, l, ROOT_MEDIA } from 'shared-base';
import { mockPark } from '../data/data.park';
import * as rt from '../utils/realtime';
import { parseGenerator, parsePosition } from '../utils/scene';
import { areaToPosition } from './helpers/area';
import { predicateAppState } from './helpers/predicates';
import { extraData } from './rotation.data';

const MOCK_POPULATE = true;

export const saga = {
  id: 'sloyd.scene',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['scene'],
  },
};

type Verb =
  | 'addModel' //
  | 'populate'
  | 'applySceneBackground'
  | 'addCharacter'
  | 'updateInstructions'
  | 'start'
  | 'clear';

const map: Record<Verb, any> = {
  addModel: addModel,
  populate: populate,
  clear: clearScene,
  applySceneBackground: applySceneBackground,
  addCharacter: addCharacter,
  updateInstructions: updateInstructions,
  start: start,
};

export function* applySceneBackground(action: any) {
  try {
    yield put(
      actions.realtimeState.patch({
        sceneBackgroundOn: true,
      })
    );
  } catch (err) {
    console.log('err =>', err);
  }
}

export function* addCharacter(action: any) {
  try {
    yield put(
      actions.characters.set('c2', {
        id: 'c2',
        generatorId: 'C-002',
        position: [1.5, 0.3, 2.2],
        rotation: [0, 0, 0],
        scale: 0.016,
        url: `${ROOT_MEDIA}/characters/C-002.fbx`,
      })
    );
  } catch (err) {
    console.log('err =>', err);
  }
}

export function* updateInstructions(action: any) {
  const { payload } = action;
  try {
    const { instructions } = payload;
    yield put(
      actions.realtimeState.patch({
        sceneIntructions: instructions,
      })
    );
    // yield put(
  } catch (err) {
    console.log('err =>', err);
  }
}

export function* start(action: any) {
  try {
    yield put(actions.appState.patch({ editMode: 'live' }));

    yield delay(350);
    yield put(actions.realtimeState.patch({ isReady: true }));

    // yield fork(describeViewport, ev);

    yield delay(300);

    yield rt.changeInstructions(
      "Pretend to be a teenager whose parents are making him learn the piano. you're sitting next to a piano and talking to a friend who wants you to come to the skatepark. you're friends for a long time so you have your lingo and you speak in short sentences. very concise"
    );
  } catch (err) {
    console.log('err =>', err);
  }
}

export function* populate(action: any) {
  const { payload } = action;
  try {
    let { models = [] } = payload;

    if (MOCK_POPULATE) {
      models = mockPark;
    }

    for (let model of models) {
      const { generatorId: raw, position, rotation: yRotate = 0 } = model;
      const generatorId = parseGenerator(raw);

      const id = guid4();

      const rotation = get(extraData, [generatorId, 'rotation'], [0, yRotate, 0]);

      const item: ISceneItem = {
        id,
        generatorId: generatorId,
        position: parsePosition(position),
        rotation,
        scale: 1,
        url: `${ROOT_MEDIA}/glbs/${generatorId}.glb?1`,
        ...extraData[generatorId],
      };

      yield* put(actions.sceneItems.patch(id, item) as any);
    }

    yield put($a('COMMANDS', 'success', action.id, {}));
  } catch (err) {
    console.log('err =>', err);
  }
}

export function* clearScene(action: any) {
  try {
    yield put(actions.sceneItems.setAll({}) as any);
  } catch (err) {
    console.log('err =>', err);
  }
}

export function* addModel(action: any) {
  try {
    const { payload } = action;
    const { generatorId, tileArea } = payload;

    const id = guid4();

    const extra = extraData[generatorId] ?? { rotation: [0, 0, 0], scale: 1 };
    const position = extra.position || areaToPosition(tileArea);

    const item: ISceneItem = {
      id,
      generatorId,
      position,
      rotation: extra.rotation,
      scale: extra.scale,
      url: `${ROOT_MEDIA}/glbs/${generatorId}.glb?1`,
    };

    yield* put(actions.sceneItems.patch(id, item) as any);

    yield put($a('COMMANDS', 'success', action.id, {}));
  } catch (err) {
    console.log('err =>', err);
  }
}

export function* onLive(action: any) {
  try {
    const realtimeState = yield* select(selectors.raw.$rawRealtimeState);
    const { sceneIntructions } = realtimeState;
    yield rt.changeInstructions(sceneIntructions, 'sage');
  } catch (err) {}
}

export function* scene(action: any) {
  const { verb } = action;

  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  l(`saga|saga.scene ${verb}`);

  yield* fork(saga, action);
}

export function* root() {
  yield takeEvery('SCENE', scene);
  yield put($a('SCENE', 'clear'));

  yield put(actions.characters.setAll({}) as any);

  yield takeEvery(predicateAppState('editMode', 'live'), onLive);
}
